import React, {useState} from 'react';
import {Button, Col, Modal, Table, Row} from "antd";
import '../modals.css';
import i18n from '../../../i18n'

export default function TableModal({isShow, setIsShow, columns, data, title = ''}) {

    let bigButtonStyle = { width: '190px', height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: "#1CAA53" };

    const textStyle = {
        textAlign: 'center',
        color: 'black'
    };

    return (
        <Modal
            title={<span className="ant-modal-title">{title}</span>}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            style={{maxWidth: '450px'}}
            align={null}
            visible={isShow}
            onCancel={() => {
                setIsShow(false);
            }}
            footer={null}
        >
            <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="modal-table"
                        locale={{ emptyText: i18n.t('main.empty') }}
                        pagination={false}
                        size="small"
                    />
                </Col>
            </Row>
        </Modal>
    );
}
